var lib_core    = require("lib-core");

var MasterModel = function(dataRoot, configuration) {
    lib_core.Model.apply(this);

    this.tabs = new lib_core.Collections.List();
    this.resizeFunctions = new lib_core.Collections.HashMap();
    this.activeTab = this.value("activeTab", true);
    this.wizardMode = this.value("wizardMode", true);

    //if wizard mode is enabled and no version is created set wizard mode flag to true
    if(configuration.wizardMode) {
        if (dataRoot.asset) {
            if(!dataRoot.asset.hasAVersion || !dataRoot.asset.hasAVersion()) {
                this.wizardMode(true);
            } else {
                this.wizardMode(false);
            }
        } else {
            this.wizardMode(true);
        }
    }
};

lib_core.inherit(MasterModel, lib_core.Model);
lib_core.JsonParser.registerClass(MasterModel, "MasterModel");
module.exports = MasterModel;
